import React, { Component } from 'react';
import '../css/style.css';
import '../components/Home.css';
import WithSearchLayout from './WithSearchLayout';
import SearchLayout from './SearchLayout';

import { translate } from "react-i18next";


class SubscriptionsLayout extends Component {

    render(){
        const { t } = this.props;
        const { params } = this.props.match
         return (<SearchLayout title={t("Abos")} eventKey="4" >
         <WithSearchLayout preURL="subscription/user" id={params.id} />
     </SearchLayout>)
       }
}

export default translate("translations")(SubscriptionsLayout);